<template>
  <AppLayout>
    <template #middle>
      <InnerContent>
        <RemindersContent />
      </InnerContent>
    </template>
    <template #outside>
      <ReminderStructureModal />
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import ReminderStructureModal from '@/features/admin/reminders/components/reminder-structure-modal/reminder-structure-modal.vue'
import InnerContent from '@/features/ui/components/inner-content/inner-content.vue'
import RemindersContent from '@/features/ui/pages/admin/reminders/reminders-content.vue'
</script>
